<template>
    <div class="tip_popup">
        <p class="topTitle" v-if="topTitle">{{ topTitle }}</p>
        <p v-html="title"></p>
        <el-button class="bind_btn" type="primary" @click="confirm">{{ btn }}</el-button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            topTitle: this.selection.topTitle,
            title: this.selection.title,
            btn: this.selection.btn
        }
    },
    methods: {
        confirm() {
            this.$emit('success')
        }
    },
}
</script>
<style lang="less" scoped>
    .tip_popup {
        p {
            text-align: center;
            margin-bottom: 0.5rem;
            font-size: 1.4rem;
            padding: 0 1rem;
            word-break: break-all;
            white-space:pre-line;
        }
        .topTitle {
            font-size: 1.8rem;
            padding: 0;
            transform: translateY(-1.5rem);
        }
        .bind_btn {
            width: 12rem;
            height: 3rem;
            border-radius: 2.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0;
            margin: 0 auto;
            margin-top: 2rem;
        }
    }
</style>